import { FC, useEffect, useState } from "react";
import { Flex, Box, Text, Image, Icon, Heading } from "@chakra-ui/react";
import { FaStar } from "react-icons/fa";

import { getStats, getReviews } from "../../services/profile";
import Star from "../../assets/images/star.png";
import { REVIEW_IMAGE_URL, PROFILE_IMAGE_URL } from "../../core/constants";

interface ReviewsProps {
  id: string;
}

export const Reviews: FC<ReviewsProps> = ({ id }) => {
  const [reviews, setReviews] = useState<any>();
  const [stats, setStats] = useState<any>();

  useEffect(() => {
    const fetchReviews = async () => {
      setStats(await getStats(id));
      setReviews(await getReviews(id));
    };

    fetchReviews();
  }, [id]);

  const ratings = [
    {
      id: 1,
      key: "1_star_ratings",
      val: 0,
    },
    {
      id: 2,
      key: "2_star_ratings",
      val: 0,
    },
    {
      id: 3,
      key: "3_star_ratings",
      val: 0,
    },
    {
      id: 4,
      key: "4_star_ratings",
      val: 0,
    },
    {
      id: 5,
      key: "5_star_ratings",
      val: 123,
    },
  ];

  return (
    <Box mt="20px">
      <Flex
        boxShadow="0px 2px 5px rgba(0, 0, 0, 0.1)"
        borderRadius={"20px"}
        bg="#FFFFFF"
        p="16px"
        gap={"32px"}
        align={"center"}
        justify={"space-between"}
      >
        <Flex flexDir={"column"} gap="4px" align={"center"} pl="5%">
          <Image src={Star} objectFit={"cover"} w={"44px"} />

          <Heading
            fontSize={"38px"}
            lineHeight={"38px"}
            color={"#267684"}
            fontFamily={"RedHatDisplay-Bold"}
          >
            {parseFloat(stats?.stats.average_rating || 0.0).toFixed(1)}
          </Heading>

          <Text fontSize={"14px"} color={"#4F4F51"}>
            {stats?.stats.review_count || 0} reviews
          </Text>
        </Flex>

        <Flex flexDir={"column"} gap="10px" justify={"flex-end"} flex={1}>
          {ratings.reverse().map((rating) => (
            <Flex gap="10px" key={rating.id} align={"center"}>
              <Text color={"#4F4F51"} fontSize={"14px"}>
                {rating.id}
              </Text>

              <Flex
                borderRadius={"20px"}
                bg="#F6F6F7"
                h="8px"
                w="100%"
                flex={1}
              >
                <Box
                  bg="#D9ED8C"
                  h="100%"
                  w={`${String(
                    (stats?.stats[rating.key] / stats?.stats.review_count) *
                      100 || 0
                  )}%`}
                  borderRadius={"20px"}
                ></Box>
              </Flex>

              <Text color={"#4F4F51"} fontSize={"14px"}>
                {stats?.stats[rating.key] || 0}
              </Text>
            </Flex>
          ))}
        </Flex>
      </Flex>

      {reviews?.length !== 0 &&
        reviews?.map((review: any) => (
          <Box
            key={review._id}
            mt="10px"
            boxShadow="0px 2px 5px rgba(0, 0, 0, 0.1)"
            borderRadius={"20px"}
            bg="#FFFFFF"
            p="16px"
          >
            <Flex gap={"6px"}>
              <Image
                w={"40px"}
                h="40px"
                borderRadius={"20px"}
                src={`${PROFILE_IMAGE_URL}/${review.profile_image}`}
                objectFit={"cover"}
              />

              <Box>
                <Text
                  fontSize={"16px"}
                  color={"#19202D"}
                  fontWeight={600}
                  lineHeight={"21px"}
                >
                  {review.full_name}
                </Text>

                <Flex align={"center"} gap="1px">
                  {new Array(review.rating_number).fill(0).map((_, index) => (
                    <Icon fontSize={"20px"} color={"#FFC266"} key={index}>
                      <FaStar />
                    </Icon>
                  ))}

                  {new Array(5 - review.rating_number)
                    .fill(0)
                    .map((_, index) => (
                      <Icon fontSize={"20px"} color={"#E9EDEF"} key={index}>
                        <FaStar />
                      </Icon>
                    ))}

                  <Text fontSize={"14px"} color={"#19202D"}>
                    {review.rating_number}
                  </Text>
                </Flex>
              </Box>
            </Flex>

            <Text mt="10px" fontSize={"14px"} color={"#4F4F51"}>
              {review.rating_text}
            </Text>

            {review.review_images.length !== 0 && (
              <Flex gap={"6px"} mt="10px">
                {review.review_images.map((image: any, index: number) => (
                  <Box key={index}>
                    <Image
                      src={`${REVIEW_IMAGE_URL}/${image.reviewImage}`}
                      objectFit={"cover"}
                      h="72px"
                      w="72px"
                      borderRadius={"12px"}
                    />
                  </Box>
                ))}
              </Flex>
            )}
          </Box>
        ))}
    </Box>
  );
};
